import { FirestoreInstance } from '../types/firestore';
import { FirestoreCollections } from '../types/firestore-collections';

export type GetFcmTokenDocOptions<
  TDocRef = unknown,
  TDb = FirestoreInstance,
> = {
  token: string;
  db: TDb;
  doc: (db: NoInfer<TDb>, path: string, ...rest: string[]) => TDocRef;
};

export const getFcmTokenDoc = <TDocRef, TDb = FirestoreInstance>(
  options: GetFcmTokenDocOptions<TDocRef, TDb>,
): TDocRef => {
  const { token, db, doc } = options;
  return doc(db, FirestoreCollections.FcmTokens, token);
};
